"use client"
import {
  Button
} from "./chunk-ZBAUJ4LY.mjs";

// src/components/close-button.ts
import { mergeStyle } from "@yamada-ui/core";
var CloseButton = mergeStyle(Button, {
  baseStyle: {
    rounded: "md",
    _active: {
      bg: ["blackAlpha.200", "whiteAlpha.200"]
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _hover: {
      bg: ["blackAlpha.100", "whiteAlpha.100"]
    }
  },
  sizes: {
    sm: {
      boxSize: 6,
      fontSize: "2xs"
    },
    md: {
      boxSize: 8,
      fontSize: "xs"
    },
    lg: {
      boxSize: 10,
      fontSize: "md"
    }
  },
  defaultProps: {
    size: "md"
  }
})({ omit: ["variants", "sizes", "defaultProps"] });

export {
  CloseButton
};
//# sourceMappingURL=chunk-77JWIFIF.mjs.map